import { mxShape } from 'mxgraph-js';
import HouseEventVertex from '../../../HCLTreeNode/FaultTreeNode/HouseEventNode/HouseEventVertex';

class HouseEventVertexDetailedShape extends mxShape {
  static SUB_LABEL_HEIGHT = 32;

  paintVertexShape(c: any, x: any, y: any, w: any, h: any): void {
    const gateSize = h * 0.28;
    const halfGateSize = gateSize / 2;
    const subLabelHeight = h * 0.2;
    const theta = 45.0;
    const adjacent = Math.tan(theta * Math.PI / 180.0) * halfGateSize;
    // separator line between main label and sub label
    c.translate(x, y);
    c.begin();
    c.moveTo(0, h - gateSize - subLabelHeight);
    c.lineTo(w, h - gateSize - subLabelHeight);
    c.fillAndStroke();
    c.close();

    c.begin();
    c.moveTo(w * 0.5, h - gateSize + 1);
    c.lineTo(w * 0.5 - halfGateSize, h - gateSize + adjacent);
    c.lineTo(w * 0.5 - halfGateSize, h);
    c.lineTo(w * 0.5 + halfGateSize, h);
    c.lineTo(w * 0.5 + halfGateSize, h - gateSize + adjacent);
    c.lineTo(w * 0.5, h - gateSize + 1);
    c.close();
    c.fillAndStroke();
    const radius = HouseEventVertex.SHAPE.RADIUS;
    c.roundrect(0, 0, w, h - gateSize, radius, radius);
    c.fillAndStroke();
  }

  public static get typeString(): string {
    return 'HouseEventVertexDetailedShape';
  }
}

export default HouseEventVertexDetailedShape;
